import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faBoxOpen, faCircleCheck, faCirclePause, faPlus } from '@fortawesome/free-solid-svg-icons';

import './MisPublicaciones.css';

const MisPublicaciones = () => {
  const [avisos, setAvisos] = useState([]);
  const [estado, setEstado] = useState('cargando');

  useEffect(() => {
    let cancelado = false;
    fetch('/api/mis-avisos', { credentials: 'include' })
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));
        if (response.status === 401) {
          window.location.href = '/login';
          return [];
        }
        if (!response.ok) throw new Error(data.error || 'No pudimos cargar tus publicaciones.');
        return data;
      })
      .then((data) => {
        if (!cancelado) {
          setAvisos(Array.isArray(data) ? data : []);
          setEstado('listo');
        }
      })
      .catch(() => { if (!cancelado) setEstado('error'); });
    return () => { cancelado = true; };
  }, []);

  if (estado === 'cargando') return <section className="mis-publicaciones estado"><span>Cargando publicaciones...</span></section>;
  if (estado === 'error') return <section className="mis-publicaciones estado"><h2>No pudimos cargar tus publicaciones</h2><p>Actualiza la pagina para volver a intentarlo.</p></section>;
  if (avisos.length === 0) {
    return <section className="mis-publicaciones estado"><FontAwesomeIcon icon={faBoxOpen} /><h2>Aun no publicaste productos</h2><p>Agrega tu primer producto a una de tus tiendas.</p><Link className="mis-publicaciones-cta" to="/cuenta#crear-aviso"><FontAwesomeIcon icon={faPlus} /> Crear publicacion</Link></section>;
  }

  const activos = avisos.filter((aviso) => aviso.Disponible && !aviso.Finalizado).length;
  return (
    <section className="mis-publicaciones">
      <header className="mis-publicaciones-header"><div><span>Gestion de catalogo</span><h2>Mis publicaciones</h2></div><Link className="mis-publicaciones-cta" to="/cuenta#crear-aviso"><FontAwesomeIcon icon={faPlus} /> Crear publicacion</Link></header>
      <div className="mis-publicaciones-summary"><span>{avisos.length} productos</span><span>{activos} activos</span></div>
      <div className="mis-publicaciones-lista">
        {avisos.map((aviso) => {
          const activo = aviso.Disponible && !aviso.Finalizado;
          return <article key={aviso.Idaviso} className="mis-publicaciones-item">
            <div className="mis-publicaciones-media">{aviso.Imagen1 ? <img src={aviso.Imagen1} alt="" /> : <FontAwesomeIcon icon={faBoxOpen} />}</div>
            <div className="mis-publicaciones-info"><span>{aviso.Tienda}</span><h3>{aviso.Titulo}</h3><p>{aviso.Descripcion}</p></div>
            <div className="mis-publicaciones-stock"><span>Stock</span><strong>{aviso.Stockproducto}</strong></div>
            <div className="mis-publicaciones-price"><span>Precio</span><strong>$ {Number(aviso.Precio).toLocaleString('es-AR')}</strong><small className={activo ? 'activo' : 'pausado'}><FontAwesomeIcon icon={activo ? faCircleCheck : faCirclePause} /> {activo ? 'Activa' : 'Pausada'}</small></div>
            <Link className="mis-publicaciones-ver" to={`/aviso/${aviso.Idaviso}`}>Ver <FontAwesomeIcon icon={faArrowRight} /></Link>
          </article>;
        })}
      </div>
    </section>
  );
};

export default MisPublicaciones;
